export const Base_URL = process.env.VUE_APP_BASE_URL;

export const Build_Version = process.env.VUE_APP_BUILD_VERSION;

export const Map_Key = process.env.VUE_APP_MAP_KEY;

export const Debug_Logs = process.env.VUE_APP_DEBUG_LOGS;
